<template>
  <div class="my-5" id="quiz-question" ref="quiz-question">
    <v-stepper elevation="0" flat outlined :rounded="false" v-model="step">
      <v-progress-linear color="primary" :value="currentProgress" />
      <v-stepper-items>
        <div v-for="(question, i) in quiz.questions">
          <v-stepper-content :step="i + 1" :key="`${i}-content`">
            <v-card elevation="0" flat>
              <v-card-title
                class="text-justify mb-1"
                style="
                  width: 100%;
                  font-size: 18px;
                  display: inline-block;
                  word-break: break-word;
                "
              >
                {{ question.value }}
              </v-card-title>
              <v-card-subtitle
                v-if="quiz.questions.length > 1"
                class="text-left"
              >
                <v-tooltip right>
                  <template #activator="{ on }">
                    <v-icon v-on="on" x-small class="mr-1" color="primary">
                      fas fa-info-circle
                    </v-icon>
                  </template>
                  <div>
                    Question Type:
                    {{ question.type.toUpperCase().replace('_', ' ') }} <br />
                    Point Value: {{ question.point_value }}
                  </div>
                </v-tooltip>
                Question {{ i + 1 }} of {{ quiz.questions.length }}
              </v-card-subtitle>
              <v-card-text class="text-left">
                <v-container fluid class="pt-0">
                  <div
                    v-if="
                      question.type === 'multiple_choice' ||
                      question.type === 'true_false'
                    "
                  >
                    <div v-if="question.is_multiple">
                      <template v-for="(answer, ai) in question.answers">
                        <v-checkbox
                          :disabled="isLoading"
                          :loading="isLoading"
                          v-model="question.user_answer"
                          :label="answer.value"
                          :value="answer.id"
                          hide-details
                        ></v-checkbox>
                      </template>
                    </div>
                    <template v-else>
                      <v-radio-group v-model="question.user_answer[0]">
                        <v-radio
                          :disabled="isLoading"
                          :loading="isLoading"
                          v-for="(answer, ai) in question.answers"
                          :key="ai"
                          :label="answer.value"
                          :value="answer.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </div>
                  <div v-if="question.type === 'checklist'">
                    <template v-for="(answer, ai) in question.answers">
                      <v-checkbox
                        :disabled="isLoading"
                        :loading="isLoading"
                        v-model="question.user_answer"
                        :label="answer.value"
                        :value="answer.id"
                        hide-details
                        color="success"
                      ></v-checkbox>
                    </template>
                  </div>
                </v-container>
              </v-card-text>
            </v-card>
            <v-row>
              <v-col class="text-left">
                <v-btn
                  :disabled="isLoading"
                  :loading="isLoading"
                  color="primary"
                  @click="step = i + 1 - 1"
                  v-if="step !== 1"
                >
                  Back
                </v-btn>
              </v-col>
              <v-col class="text-right">
                <v-btn
                  :disabled="isLoading"
                  :loading="isLoading"
                  color="primaryMain"
                  class="primaryMainText--text"
                  @click="step = i + 1 + 1"
                  v-if="step < quiz.questions.length"
                >
                  Next Question
                </v-btn>
                <v-btn
                  :disabled="isLoading"
                  :loading="isLoading"
                  color="primaryMain"
                  class="primaryMainText--text"
                  @click="submitQuiz"
                  v-else
                >
                  Submit
                </v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>
        </div>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
export default {
  name: 'TakeQuiz',
  props: {
    quiz: {
      type: Object,
      required: true,
    },
    submitQuiz: {
      type: Function,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    step: 1,
  }),

  computed: {
    currentProgress() {
      return (this.step / this.quiz.questions.length) * 100;
    },
  },

  methods: {
    nextStep(n) {
      if (n === this.quiz.questions.length) {
        this.step = 1;
      } else {
        this.step = n + 1;
      }
    },
  },
};
</script>

<style scoped></style>
